export const PHONE_PATTERN = /^(?:\d{10}|\d{3}-\d{3}-\d{4})$/; 